import React from 'react';
import { toast } from 'sonner';

/** Small "ArcGIS traceability" strip shown at the bottom of a record's expanded
 * detail — objectid/globalid are the only way to trace a row back to the
 * source Survey123 layer when investigating a data issue, so they must be
 * visible somewhere even though they're hidden from the generic field grid. */
export function TrazabilidadFooter({ row }) {
  const objectid = row.objectid || row.OBJECTID;
  const globalid = row.globalid || row.GlobalID || row.GLOBALID;
  const syncedAt = row._synced_at;
  if (!objectid && !globalid) return null;

  const copy = (val) => {
    navigator.clipboard?.writeText(String(val));
    toast.success('Copiado al portapapeles');
  };

  const syncedLabel = syncedAt
    ? new Date(syncedAt).toLocaleString('es-ES', { timeZone: 'Europe/Madrid', dateStyle: 'short', timeStyle: 'short' })
    : null;

  return (
    <div
      className="px-4 py-2 flex flex-wrap items-center gap-x-4 gap-y-1 border-t text-[10px]"
      style={{ borderColor: 'var(--vz-border-subtle)', color: 'var(--vz-text-muted)' }}
      data-testid="trazabilidad-footer"
    >
      <span className="uppercase tracking-wider font-semibold">Trazabilidad ArcGIS</span>
      {objectid && (
        <button
          type="button"
          onClick={() => copy(objectid)}
          className="font-mono hover:underline"
          title="Copiar OBJECTID"
          data-testid="trazabilidad-objectid"
        >
          OBJECTID: {objectid}
        </button>
      )}
      {globalid && (
        <button
          type="button"
          onClick={() => copy(globalid)}
          className="font-mono hover:underline truncate max-w-[220px]"
          title="Copiar GlobalID"
          data-testid="trazabilidad-globalid"
        >
          GlobalID: {globalid}
        </button>
      )}
      {syncedLabel && <span data-testid="trazabilidad-synced-at">Sincronizado: {syncedLabel} (Madrid)</span>}
    </div>
  );
}

export default TrazabilidadFooter;
